
export class FanModel {
    fanId: number;
    status: string; // Active, Enrolled not active, In Progress
    profile: number; // ProfileModel profileId
    selected?: boolean;
}

export class MdmDetails {
    emmProductCode: string;
    signupStatus: string;
    emmAccountId: string;
    otherProducts: Array<OtherProducts>;
    constructor() {
        this.emmProductCode = undefined;
        this.signupStatus = undefined;
        this.emmAccountId = undefined;
        this.otherProducts = [];
    }
}

export class OtherProducts {
    emmProductCode: string;
    signupStatus: string;
    emmAccountId: string;
    constructor() {
          this.emmProductCode = undefined;
          this.signupStatus = undefined;
          this.emmAccountId = undefined;
    }
}

export class RemoveList {
    emmProductCode: string;
    emmAccountId: string;
    fanList: {};
}



